export default __webpack_public_path__ + "static/media/video-player.b2ea402e.svg";